import React from 'react';

export const GalleryImage: React.FC<{ src: string; alt: string }> = ({ src, alt }) => (
    <div className="h-full overflow-hidden rounded-lg border-2 border-border hover:border-primary transition-all duration-300">
        <img src={src} alt={alt} className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500 cursor-pointer" />
    </div>
);